import { useScrollPaddingTopHandler } from '@portal/atoms/scrollPaddingTopAtom';
import { useRef, type PropsWithChildren } from 'react';

import styles from './styles.module.scss';

export const StickyHeaderWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollPaddingTopHandler({ type: 'sticky-header' }, ref);
  return (
    <div ref={ref} className={styles.stickyHeaderWrapper}>
      {children}
    </div>
  );
};
